export const HOTEL_PAGE_PARAM_ROOM_ID = 'roomId';
export const HOTEL_PAGE_PARAM_RATE_ID = 'roomRateId';
export const PARAM_CTA_SELECT = 'ctaSelect';
export const FILTER_CHANGE = 'Forms.searchFilters.FILTER_CHANGE';
export const GLOBAL_LOADER_TIMEOUT = 1000;
export const GLOBAL_LOADER_TOGGLE = 'GLOBAL_LOADER_TOGGLE';
export const FETCH_CONDITIONS_REQUEST = 'SearchResults.FETCH_CONDITIONS_REQUEST';
export const FETCH_CONDITIONS_SUCCESS = 'SearchResults.FETCH_CONDITIONS_SUCCESS';
export const RESET_CONDITIONS_SUCCESS = 'SearchResults.RESET_CONDITIONS_SUCCESS';
export const FETCH_FAMILY_FRIENDLY_REQUEST = 'FETCH_FAMILY_FRIENDLY_REQUEST';

export const FETCH_FAMILY_FRIENDLY_DATA_SUCCESS = 'FETCH_FAMILY_FRIENDLY_DATA_SUCCESS';
export const DESTINATIONS_PAGE_VIEW = 'destinationPage'
